export const FRANCHISE_INFO_LIST = [
    { slug: 'activity', title: 'Вид деятельности' },
    { slug: 'year_launch', title: 'Год запуска' },
    { slug: 'number_franchisees', title: 'Количество франчайзи' },
    { slug: 'number_franchise_points', title: 'Количество франчайзинговых точек' },
    { slug: 'number_own_points', title: 'Количество собственных точек' },
    { slug: 'location', title: 'География' },
    { slug: 'initial_investments', title: 'Стартовые инвестиции' },
    { slug: 'monthly_expenses', title: 'Ежемесячные расходы' },
    { slug: 'monthly_revenue', title: 'Ежемесячная выручка' },
    { slug: 'monthly_net_profit', title: 'Ежемесячная чистая прибыль' },
    { slug: 'payback', title: 'Срок окупаемости' },
    { slug: 'annual_roi', title: 'Годовой ROI' },
    { slug: 'special_sign', title: 'Особые отметки' },
];
